import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { FormGroup, Input, Row, Col, Label } from "reactstrap";
import Axios from "axios";
import { FormControl, FormControlLabel, IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import ProfileImageUploader from "./ProfileImageUploader";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { toTitleCase } from "../../../../helpers/stringHelper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import Checkbox from "@material-ui/core/Checkbox";

export default function UserDetailsEditDialog(props) {
  const [personDetails, setPersonDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [changeList, setChangeList] = useState({});
  const [saved, setSaved] = useState(false);

  const { hubConnection, linkedIn, clientKey, connected, eventId, title, allowedTitle, profileImage, name, anonymous, chatAlias, chatAdmin, personTypes } = props;

  useEffect(() => {
    setPersonDetails({ linkedIn, title, profileImage, chatAdmin, chatAlias });
    if (hubConnection) {
      hubConnection.on("onProfileDetailsUpdate", () => {
        setChangeList([]);
        setSaved(true);
      });
    }
  }, []);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (path, v) => {
    const newChangeList = Array.from(changeList);

    let value = v;

    if (path != "profileImage") {
      /* value = value.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
        return "&#" + i.charCodeAt(0) + ";";
      }); */
    }

    var index = newChangeList.indexOf(newChangeList.find((nc) => nc.name == toTitleCase(path)));
    if (index > -1) {
      newChangeList[index].value = value;
    } else {
      newChangeList.push({ name: toTitleCase(path), value });
    }

    setChangeList(newChangeList);
    setPersonDetails({ ...personDetails, [path]: value });
    setHasChanged(true);
  };

  const onDeleteImage = () => {
    handleChange("profileImage", "");

    deleteImage();

    setHasChanged(true);

    setImageUploaded(false);
  };

  const onImageSet = (path, value) => {
    setImageUploaded(true);
    handleChange(path, value);
  };

  const deleteImage = () => {
    Axios.delete(`./api/meeting/deleteprofileimage/${clientKey}`).catch((err) => console.error(err));
  };
  const uploadImage = () => {
    Axios.post(`./api/meeting/uploadprofileimage`, {
      imageData: personDetails.profileImage,
      badgeNo: clientKey,
    })
      .then(({ data }) => {
        const { url } = data;
        handleChange("profileImage", url);
        let newChangeList = Array.from(changeList);
        var index = newChangeList.indexOf(newChangeList.find((nc) => nc.name == "ProfileImage"));
        if (index > -1) {
          newChangeList[index].value = url;
        }

        save(newChangeList);
      })
      .catch((err) => console.error(err));
  };

  const beforeSave = () => {
    const { profileImage, title, linkedIn } = personDetails;
    if (profileImage && imageUploaded) {
      uploadImage(profileImage);
    } else {
      save(changeList);
    }
  };
  const save = (requestList = []) => {
    if (!connected || !hubConnection || hubConnection.connectionState != 1) return;
    hubConnection.invoke("updateProfileDetails", {
      eventId,
      clientKey,
      props: requestList,
    });
    setHasChanged(false);
    setImageUploaded(false);
    handleClose();
  };

  return (
    <div>
      <IconButton style={{ color: name.color }} onClick={handleClickOpen}>
        <SettingsIcon />
      </IconButton>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
        <div></div>
        <div></div>
        <DialogTitle id="responsive-dialog-title">
          <EventLabel2 groupName="DigitalMeeting.UserCard" name="EditProfile" />
        </DialogTitle>
        <DialogContent style={{ minWidth: 400 }}>
          <Row>
            <ProfileImageUploader digitalArena={true} onDeleteImage={onDeleteImage} setImage={(v) => onImageSet("profileImage", v)} source={personDetails.profileImage} />
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label>
                  {" "}
                  <EventLabel2 groupName="DigitalMeeting.UserCard" name="JobTitle" />
                </Label>
                <div className="jir-input-prepend">
                  <AssignmentIndIcon style={{ marginRight: 10 }} />
                  <Input value={personDetails.title || title || ""} maxLength="50" onChange={(e) => handleChange("title", e.target.value)} />
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label>
                  <EventLabel2 groupName="DigitalMeeting.UserCard" name="LinkedInLink" />
                </Label>
                <div className="jir-input-prepend">
                  <LinkedInIcon style={{ marginRight: 10 }} />
                  <Input value={personDetails.linkedIn || linkedIn || ""} onChange={(e) => handleChange("linkedIn", e.target.value)} />
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormControl component="fieldset" /* className={classes.formControl} */>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={personDetails.anonymous ? personDetails.anonymous == "True" || personDetails.anonymous == true : anonymous}
                        onChange={(e) => handleChange("anonymous", e.target.checked ? "True" : "False")}
                      />
                    }
                    label={
                      <Label style={{ marginBottom: 0, fontSize: 14 }}>
                        <EventLabel2 groupName="DigitalMeeting.UserCard" name="HideMyNameFromOtherParticipants" />
                      </Label>
                    }
                  />
                </FormGroup>
              </FormControl>
            </Col>
          </Row>
          {Array.isArray(personTypes) && personTypes.includes(304) ? (
            <Row>
              <Col>
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={personDetails.chatAdmin ? personDetails.chatAdmin == "True" || personDetails.chatAdmin == true : chatAdmin}
                          onChange={(e) => handleChange("chatAdmin", e.target.checked ? "True" : "False")}
                        />
                      }
                      label={
                        <Label style={{ marginBottom: 0, fontSize: 14 }}>
                          <EventLabel2 groupName="DigitalMeeting.UserCard" name="MakeMeChatAdmin" />
                        </Label>
                      }
                    />
                  </FormGroup>
                </FormControl>
              </Col>
            </Row>
          ) : null}
          {Array.isArray(personTypes) && personTypes.includes(304) && (personDetails.chatAdmin == "True" || personDetails.chatAdmin == true) ? (
            <Row>
              <Col>
                <FormGroup>
                  <Label>
                    {" "}
                    <EventLabel2 groupName="DigitalMeeting.UserCard" name="ChatAlias" />
                  </Label>
                  <div className="jir-input-prepend">
                    <AssignmentIndIcon style={{ marginRight: 10 }} />
                    <Input value={personDetails.chatAlias || ""} maxLength="50" onChange={(e) => handleChange("chatAlias", e.target.value)} />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            <SystemLabel name="Cancel" />
          </Button>
          <Button disabled={!hasChanged} onClick={beforeSave} color="primary">
            <SystemLabel name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
